import { render, staticRenderFns } from "./Followup.vue?vue&type=template&id=c1db425c&scoped=true&"
import script from "./Followup.vue?vue&type=script&lang=js&"
export * from "./Followup.vue?vue&type=script&lang=js&"
import style0 from "./Followup.vue?vue&type=style&index=0&id=c1db425c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1db425c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VDataTable,VIcon,VSpacer,VToolbar})
